(function () {
  var swiperContainer = document.querySelector('.rv-product-swiper');
  var swiperInstance = null;
  if (swiperContainer && typeof Swiper !== 'undefined') {
    swiperInstance = new Swiper('.rv-product-swiper', {
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  // La libreria Swiper no esta en el tema, asi que el bloque de arriba nunca llega a ejecutarse
  // y la galeria se maqueta como carrusel nativo con scroll-snap (ver rv-custom.css). Aqui solo
  // se pintan los puntos y se marca el activo segun el scroll: sin ellos, en movil no hay forma
  // de saber que hay mas fotos. Se reutiliza el marcado .swiper-pagination que ya estaba.
  var galleryTrack = swiperContainer ? swiperContainer.querySelector('.swiper-wrapper') : null;
  var galleryDots = swiperContainer ? swiperContainer.querySelector('.swiper-pagination') : null;
  var gallerySlides = galleryTrack ? galleryTrack.querySelectorAll('.swiper-slide') : [];
  var setActiveDot = function () {};

  if (!swiperInstance && galleryTrack && galleryDots && gallerySlides.length > 1) {
    var bullets = [];

    Array.prototype.forEach.call(gallerySlides, function (slide, index) {
      var bullet = document.createElement('button');
      bullet.type = 'button';
      bullet.className = 'swiper-pagination-bullet';
      bullet.setAttribute('aria-label', 'Ver foto ' + (index + 1) + ' de ' + gallerySlides.length);
      bullet.addEventListener('click', function () {
        galleryTrack.scrollTo({ left: galleryTrack.clientWidth * index, behavior: 'smooth' });
      });
      galleryDots.appendChild(bullet);
      bullets.push(bullet);
    });

    setActiveDot = function () {
      var index = Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth);
      bullets.forEach(function (bullet, i) {
        var isActive = i === index;
        bullet.classList.toggle('swiper-pagination-bullet-active', isActive);
        bullet.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    setActiveDot();
    galleryTrack.addEventListener('scroll', function () {
      window.requestAnimationFrame(setActiveDot);
    }, { passive: true });
    window.addEventListener('resize', setActiveDot);
  }

  var variantSelectors = document.querySelectorAll('variant-selector');
  variantSelectors.forEach(function(selector) {
    var radios = selector.querySelectorAll('.pm__variant-input');
    var variantData = JSON.parse(selector.querySelector('[data-variant-json]').textContent);
    var idInput = document.querySelector('.product-variant-id');
    var priceValue = document.querySelector('.pm__price-value');
    var submitBtn = document.querySelector('button[name="add"]');
    var ctaLabel = document.querySelector('.pm__cta-label span:last-child');

    function updateVariant() {
      var selectedOptions = Array.from(selector.querySelectorAll('.pm__variant-input:checked')).map(function(radio) {
        return radio.value;
      });

      var currentVariant = variantData.find(function(variant) {
        return selectedOptions.every(function(option, index) {
          return variant['option' + (index + 1)] === option;
        });
      });

      if (currentVariant) {
        if (idInput) idInput.value = currentVariant.id;
        
        if (priceValue) {
          var priceStr = (currentVariant.price / 100).toFixed(2).replace('.', ',') + ' €';
          priceValue.textContent = priceStr;
        }

        if (submitBtn) {
          if (currentVariant.available) {
            submitBtn.disabled = false;
            if (ctaLabel) ctaLabel.textContent = 'AÑADIR AL CARRITO';
          } else {
            submitBtn.disabled = true;
            if (ctaLabel) ctaLabel.textContent = 'AGOTADO';
          }
        }

        if (currentVariant.featured_image && swiperContainer) {
          var targetIndex = -1;
          var slides = swiperContainer.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate) img');
          slides.forEach(function(img, index) {
            if (img.src.includes(currentVariant.featured_image.src.split('?')[0])) {
              targetIndex = index;
            }
          });
          if (targetIndex !== -1) {
            if (swiperInstance) {
              swiperInstance.slideToLoop(targetIndex);
            } else if (galleryTrack) {
              // Carrusel nativo: en movil se desplaza al hueco de esa foto; en desktop las fotos
              // estan todas a la vista en la rejilla, asi que solo se lleva el scroll a la suya.
              if (galleryTrack.scrollWidth > galleryTrack.clientWidth) {
                galleryTrack.scrollTo({ left: galleryTrack.clientWidth * targetIndex, behavior: 'smooth' });
                setActiveDot();
              } else if (gallerySlides[targetIndex]) {
                gallerySlides[targetIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }
            }
          }
        }
      }
    }

    radios.forEach(function(radio) {
      radio.addEventListener('change', updateVariant);
    });
  });
})();
